import { formatISO, parseISO } from 'date-fns';

/**
 * Creates a UTC date at midnight from a date or string input
 * This ensures consistent date handling without timezone issues
 */
export function utcFromDate(dateInput: Date | string): Date {
  // If input is a string, parse it first
  const date = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;
  
  // Format as YYYY-MM-DD and append T00:00:00Z to create UTC midnight
  return parseISO(formatISO(date, { representation: 'date' }) + 'T00:00:00Z');
}
